import { AxiosError } from "axios";

type AxiosStatusHandlers = Record<number, CallableFunction>;

export function handleAxiosError(handlers: AxiosStatusHandlers) {
  return (e: unknown) => {
    if (e instanceof AxiosError) {
      const status = e.response?.status;
      if (status !== undefined && status in handlers) {
        return handlers[status](e);
      }
    }

    throw e;
  };
}
